import { AiOutlineDelete } from 'react-icons/ai';
import { TbRestore } from 'react-icons/tb';
import { Card } from '../../../../../../components/card/card';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { Table } from '../../../../../../features/table/table';
import { TableFilterInput } from '../../../../../../features/table/table-filter/table-filter-input/table-filter-input';
import { TableFilterMultiSelect } from '../../../../../../features/table/table-filter/table-filter-multi-select/table-filter-multi-select';
import { TableFilterSingleSelect } from '../../../../../../features/table/table-filter/table-filter-single-select/table-filter-single-select';
import { useLang } from '../../../../../../hooks/use-lang';
import { ageOptions, getContentFields, getContentFieldValue, sexOptions } from '../../helpers';

import { HasAccess } from '../../../../../../features/has-access/has-access';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { useLeadStore } from '../../../../../../store/use-lead-store';
import s from './leads-table.module.css';

export const LeadsTable = () => {
  const { t, getLocale } = useLang();
  const { list, isLoadingFetch } = useLeadStore();
  const { addQueryParams } = useQueryParams();

  return (
    <Card>
      <Table
        withArchive
        id="leads-list"
        columnSettings
        isLoading={isLoadingFetch}
        frontPagination
        className={s.table}
        onEmpty={{
          title: t('Список лидов пуст'),
          text: t('Дождитесь пока хоть один клиент оставит информацию'),
        }}
        cols={{
          name: {
            label: t('ФИО'),
            filter: (
              <TableFilterInput
                name="name"
                suggestOptions={list?.map((item) => getContentFieldValue(item, 'full_name'))}
              />
            ),
          },
          phone: {
            label: t('Телефон'),
            filter: (
              <TableFilterInput
                name="phone"
                suggestOptions={list?.map((item) => getContentFieldValue(item, 'phone'))}
              />
            ),
          },
          email: {
            label: t('E-mail'),
            filter: (
              <TableFilterInput
                name="email"
                suggestOptions={list?.map((item) => getContentFieldValue(item, 'email'))}
              />
            ),
          },
          sex: {
            label: t('Пол'),
            filter: <TableFilterSingleSelect name="sex" options={sexOptions} />,
          },
          age: {
            label: t('Возраст'),
            filter: <TableFilterMultiSelect name="age" options={ageOptions} />,
          },
          rating: {
            label: t('Рейтинг'),
            filter: <TableFilterInput name="rating" />,
          },
          source: {
            label: t('Источник'),
            filter: <TableFilterInput name="source" />,
          },
          actions: { label: t('Действия') },
        }}
        rows={list?.map((item) => {
          const { name, phone, email, sex, age } = getContentFields(item);

          return {
            name,
            phone,
            email,
            sex: t(sex),
            age,
            rating: item.rating?.feedbacks || 0,
            source: getLocale(item.source),
            actions: (
              <HasAccess service="lead" permissions={['write']}>
                {item.is_deleted ? (
                  <IconButton
                    tooltip={t('Восстановить')}
                    variant="secondary"
                    size="sm"
                    onClick={() =>
                      addQueryParams({
                        restoreId: String(item.id),
                        restoreName: name,
                      })
                    }
                  >
                    <TbRestore />
                  </IconButton>
                ) : (
                  <IconButton
                    tooltip={t('Удалить')}
                    size="sm"
                    variant="secondary"
                    onClick={() =>
                      addQueryParams({
                        deleteId: item.id.toString(),
                        deleteName: name,
                      })
                    }
                  >
                    <AiOutlineDelete />
                  </IconButton>
                )}
              </HasAccess>
            ),
          };
        })}
      />
    </Card>
  );
};
